export function LaserTypeFactory() {
    return function LaserType() {
        this.name = null;
        this.code = null;
        this.id = null;
    }
}
